import idx from 'idx'
import axios from 'axios'
import {API_URL} from 'config'

import initialState from 'reducers/initialState'
import errorDispatcher from 'utils/errorDispatcher'
import {getAuthorizationHeader} from 'utils/session'

import {SELECT_GROUP} from 'modules/group'
import {SELECT_ORGANISATION} from 'modules/organisation'

// Actions
export const RESET_MAP = 'RESET_MAP'
export const FOCUS_TRAP = 'FOCUS_TRAP'
export const FOCUS_GROUP = 'FOCUS_GROUP'
export const MAP_CONTENT_CHANGED = 'MAP_CONTENT_CHANGED'
export const API_GET_MAP_TRAPS_REQUEST = 'API_GET_MAP_TRAPS_REQUEST'
export const API_GET_MAP_TRAPS_SUCCESS = 'API_GET_MAP_TRAPS_SUCCESS'
export const API_GET_MAP_TRAPS_ERROR = 'API_GET_MAP_TRAPS_ERROR'

// Reducer
export default function reducer(state = initialState.map, action) {
    switch (action.type) {
        case SELECT_ORGANISATION:
            return {
                ...initialState.map,
            }
        case API_GET_MAP_TRAPS_REQUEST:
            return {
                ...state,
                data: initialState.map.data
            }
        case API_GET_MAP_TRAPS_SUCCESS:
            return {
                ...state,
                data: action.traps
            }
        case FOCUS_GROUP:
            return {
                ...state,
                focusedTrap: null,
                focusedGroup: action.group
            }
        case FOCUS_TRAP:
            return {
                ...state,
                data: state.data,
                focusedGroup: null,
                focusedTrap: action.trap.historyUuid
            }
        case SELECT_GROUP:
            return {
                ...initialState.map,
                data: state.data,
                activeGroup: action.group.groupUuid || action.group.uuid
            }
        case RESET_MAP:
            return {
                ...state,
                data: state.data,
                focusedTrap: null,
                focusedGroup: null,
            }
        case MAP_CONTENT_CHANGED:
            return {
                ...state,
                data: null
            }
        default:
            return state
    }
}

// Action Creators
export function activeGroup(group) {
    return async function dispatcher(dispatch) {
        dispatch({type: SELECT_GROUP, group})
    }
}

export function focusTrap(trap) {
    return async function dispatcher(dispatch) {
        dispatch({type: FOCUS_TRAP, trap})
    }
}

export function focusGroup(group) {
    return async function dispatcher(dispatch) {
        dispatch({type: FOCUS_GROUP, group})
    }
}

export function resetMapState() {
    return async function dispatcher(dispatch) {
        dispatch({type: RESET_MAP})
    }
}

export function getMapTraps(organisation) {
    return async function dispatcher(dispatch) {
        dispatch({type: API_GET_MAP_TRAPS_REQUEST})

        try {
            const result = await axios.get(`${API_URL}/project/${organisation.uuid}/groupline`, getAuthorizationHeader())
            const traps = result.data

            // historyUuid is used as an id for map items (and possibly other things). Bit of a hack now that
            // there isn't one for active traps. Let's see if it's sufficient.
            traps.groupLineDetails.forEach(_ => {
                if (!_.historyUuid)
                    _.historyUuid = "ACTIVE" + Math.random().toString().substring(2)
            })

            dispatch({type: API_GET_MAP_TRAPS_SUCCESS, traps})
        }
        catch (error) {
            console.error("getMapTraps", error)
            const errorCode = idx(error, _ => _.response.status) || ''
            errorDispatcher(errorCode, API_GET_MAP_TRAPS_ERROR, dispatch)
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/map.js